import classNames from "classnames";
import type { ReactElement } from "react";
import Colors from "ui-kit/colors";
import styles from "./IconFrame.module.css";

const getBgColor = (color: Colors) => {
  switch (color) {
    case Colors.blue300:
      return Colors.blue100;
    case Colors.green300:
      return Colors.green100;

    default:
      return Colors.blue100;
  }
};

export const IconFrame = ({
  icon,
  iconSize = 24,
  className,
  style = "normal",
  iconColor,
  ariaHiddenIcon,
}: {
  /** A glyph from `ui-kit/icons`, e.g. `<Paw />`. Sized and coloured here. */
  icon: ReactElement;
  iconSize?: 24 | 16;
  className?: string;
  style?: "normal" | "round";
  /** Drives the glyph, and the disc behind it in the `round` style. */
  iconColor: Colors;
  ariaHiddenIcon?: boolean;
}) => {
  const bgColor = style != "normal" ? getBgColor(iconColor) : undefined;

  return (
    <div
      className={classNames(styles.frame, styles[style], className)}
      style={{ backgroundColor: bgColor }}
    >
      <span
        className={styles.icon}
        style={{ color: iconColor, fontSize: iconSize }}
        aria-hidden={ariaHiddenIcon ? true : undefined}
      >
        {icon}
      </span>
    </div>
  );
};
